export default {
    humanVsComputer: 'humanVsComputer',
    computerVsComputer: 'computerVsComputer'
};